import { render, staticRenderFns } from "./str.vue?vue&type=template&id=87d19098&scoped=true&lang=pug"
import script from "./str.vue?vue&type=script&lang=js"
export * from "./str.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=87d19098&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d19098",
  null
  
)

export default component.exports